import type { MaskPreset } from "../types";
import { BaseMaskAdapter } from "./base-adapter";

const PHONE_MASKS: Record<Extract<MaskPreset, "phone" | "phone-with-country">, string> = {
  phone: "(99) 9?9999-9999",
  "phone-with-country": "+99 (99) 9?9999-9999",
};

export class PhonePresetAdapter extends BaseMaskAdapter {
  constructor(preset: "phone" | "phone-with-country") {
    const maskPattern = PHONE_MASKS[preset];
    super(maskPattern);
  }

  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyGenericMask(String(value));
  }

  parseFromInput(inputValue: string): { value: string; formatted: string } {
    if (inputValue === "" || this.cleanValue(inputValue) === "") {
      return { value: "", formatted: "" };
    }

    const formatted = this.applyGenericMask(inputValue);
    const cleanValue = this.cleanValue(formatted);

    return {
      value: cleanValue,
      formatted,
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyGenericMask(String(value));
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    return /^\d$/.test(key);
  }
}
